export default "__VITE_ASSET__Bxbgv2Sq__"